import { render, staticRenderFns } from "./IconFaceConfused.vue?vue&type=template&id=57137f2e&"
import script from "./IconFaceConfused.vue?vue&type=script&lang=js&"
export * from "./IconFaceConfused.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports